// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__8Co1U","countInfo":"Pagination_countInfo__jdklB","paginationControls":"Pagination_paginationControls__y1oTg"};